"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.communications_search.name': 'Wyszukiwanie Komunikacji',
    'tools.communications_search.description': 'Przeszukuj i przeglądaj dane komunikacyjne, w tym podsumowania grup, logi śledzenia i ustawienia według numeru telefonu',
};
